<a *ngIf="group_model" class="grid-link" [routerLink]="['/groups', group_model.id]">{{ text }}</a>

